import { onBeforeMount } from 'vue'
import useAppStore from '@/h5/stores/app'
import golbalDataSourceSingle from '@/h5/hooks/useDataSource'
import { cloneDeep } from 'lodash'

// 全局单例对象
const listRequstMaps = (() => {
  let instance
  const createInstance = () => {
    return {}
  }

  return () => {
    if (!instance) {
      instance = createInstance()
    }
    return instance
  }
})()

const updateNestedData = (obj, path, value) => {
  if (path.length === 1) {
    obj[path[0]] = value
  } else {
    const nextKey = path.shift()
    if (Object.prototype.hasOwnProperty.call(obj, nextKey)) {
      updateNestedData(obj[nextKey], path, value)
    } else {
      obj[nextKey] = path.length === 1 ? {} : {}
      updateNestedData(obj[nextKey], path, value)
    }
  }
}

const useListDataSource = () => {
  // 全局状态
  let appStore = null
  // 请求接口映射
  const listRequstMapsInstance = listRequstMaps()

  /**
   * 初始化列表数据
   * @param {*} source
   */
  const initListData = async (source) => {
    /**
     * 1. 有自定义参数, 刷新默认列表参数
     * 2. 无自定义参数, 判断已初始化列表数据
     * 3. 有初始化配置,则保留当前已获得的列表数据内容及配置
     */
    if (!appStore) {
      appStore = useAppStore()
    }
    const hasCustom = listRequstMapsInstance[source.uuid]?.customParams ? true : false
    if (hasCustom || !listRequstMapsInstance[source.uuid]) {
      listRequstMapsInstance[source.uuid] = {
        current: 1,
        hasMore: true
      }
    }
    if (hasCustom) {
      // 刷新默认列表参数
      const config = golbalDataSourceSingle.apiRequstMaps[source.uuid]
      if (config) {
        const res = await golbalDataSourceSingle.customActionRequest(source.uuid, {})
        appStore.setPageDataSource(source.uuid, res.data || null)
      }
    }
  }

  /**
   * 保存当前列表自定义参数
   * @param {*} source
   * @param {*} params
   */
  const setCustomParams = (uuid, params) => {
    if (listRequstMapsInstance[uuid] && params) {
      // 判断是否为分页列表数据源,分页列表数据源会在initListData中初始化
      listRequstMapsInstance[uuid] = {
        current: 1,
        hasMore: true,
        customParams: params
      }
    }
  }

  /**
   * 分页获取列表数据
   * @param {*} source
   * @returns
   */
  const getList = async (source) => {
    if (!appStore) {
      appStore = useAppStore()
    }
    const requstInfo = golbalDataSourceSingle.apiRequstMaps[source.uuid]
    if (requstInfo?.unity) {
      // 游戏服分页列表接口
      let size = 10
      if (requstInfo?.requestParams?.length) {
        requstInfo.requestParams.forEach((params) => {
          if (params.key === 'size' && typeof params.value === 'string') {
            size = Number(params.value)
          }
        })
      }
      return getUnityList(source, size)
    } else {
      // 平台服分页列表接口
      return getPlatformList(source)
    }
  }

  const getUnityList = async (source, size) => {
    if (!listRequstMapsInstance[source.uuid].hasMore) {
      return
    }
    // console.log('---列表加载')
    const params = Object.assign({}, listRequstMapsInstance[source.uuid]?.customParams, { current: listRequstMapsInstance[source.uuid].current + 1 })
    console.log('----params', params)
    const res = await golbalDataSourceSingle.customActionRequest(source.uuid, params)
    const oldData = appStore.getPageDataSource(source.uuid)
    let oldList = cloneDeep(oldData)
    let listData = cloneDeep(oldData)
    let newListData = cloneDeep(res.data)
    const indices = source.keys.split('.')
    for (let i = 0; i < indices.length; i++) {
      const key = indices[i]
      listData = listData[key]
      newListData = newListData[key]
      oldList = oldList[key]
    }

    // 数组拼接
    if (newListData && newListData.length) {
      listData = listData.concat(newListData)
    }
    if (!newListData || newListData.length < size || listData.length === oldList.length) {
      listRequstMapsInstance[source.uuid].hasMore = false
    }
    // 判断数组是否变化，未变化则不更新
    // console.log('--oldList--', listData.length, oldList.length, newListData)
    if (listData.length !== oldList.length) {
      listRequstMapsInstance[source.uuid].current += 1
      updateNestedData(oldData, indices, listData)
      appStore.setPageDataSource(source.uuid, oldData)
    }
  }

  const getPlatformList = async (source) => {
    if (!listRequstMapsInstance[source.uuid].hasMore) {
      return
    }
    // console.log('---列表加载')
    const params = Object.assign({}, listRequstMapsInstance[source.uuid]?.customParams, { current: listRequstMapsInstance[source.uuid].current + 1 })
    const res = await golbalDataSourceSingle.customActionRequest(source.uuid, params)
    const oldData = appStore.getPageDataSource(source.uuid)
    let oldList = cloneDeep(oldData)
    let listData = cloneDeep(oldData)
    let newListData = cloneDeep(res.data)
    const indices = source.keys.split('.')
    for (let i = 0; i < indices.length; i++) {
      const key = indices[i]
      listData = listData[key]
      newListData = newListData[key]
      oldList = oldList[key]
    }

    // 数组拼接
    if (newListData && newListData.length) {
      listData = listData.concat(newListData)
    }
    if (listData.length >= res.data?.total || !res.data?.total) {
      listRequstMapsInstance[source.uuid].hasMore = false
    }
    // 判断数组是否变化，未变化则不更新
    // console.log('--oldList--', listData.length, oldList.length, newListData)
    if (listData.length !== oldList.length) {
      listRequstMapsInstance[source.uuid].current += 1
      updateNestedData(oldData, indices, listData)
      appStore.setPageDataSource(source.uuid, oldData)
      console.log('刷新列表数据', oldData)
    }
  }

  onBeforeMount(() => {
    appStore = useAppStore()
  })

  return {
    getList,
    initListData,
    setCustomParams,
    listRequstMaps: listRequstMapsInstance
  }
}

export default useListDataSource
